module.exports = (__webpack_require__(8593))(42);